<script>
  import base from './Base/Base'

  export default {
    mixins: [base],
    data() {
      return {
        url: '/log/system',
        page: {
          currentPage: 1,
          total: 0,
          pageSize: 20
        },
        // 表格数据
        data: [],
        // curd组件
        option: {
          viewBtn: true, // 查看按钮显隐
          addBtn: true, // 增加按钮显隐
          editBtn: true, // 修改按钮显隐
          delBtn: true, // 删除按钮显隐
          columnBtn: false, // 列显隐按钮
          headerAlign: 'center', // 表头居中
          align: 'center', // 表内容 居中
          searchMenuSpan: 5, // 搜索同行 搜索所占宽度
          stripe: true,  // 斑马纹
          index: true, // 行首 索引
          column: [
            {
              label: '管理员',
              prop: 'admin_id',
              type: 'select',
              props: {
                label: 'username',
                value: 'id'
              },
              dicUrl: this.config.baseURL + '/dic/admin',
              search: true,
              // 以下两个属性同时使用可以彻底不在列表中显示
              hide: true, // 隐藏列
              showColumn: false // 是否加入动态现隐列
            },
            {
              label: '管理员',
              prop: 'admin_username'
            },
            {
              label: 'url',
              prop: 'path'
            },
            {
              label: '类型',
              prop: 'method'
            },
            {
              label: 'ip',
              prop: 'ip'
            },
            {
              label: '数据',
              prop: 'input',
              // 以下两个属性同时使用可以彻底不在列表中显示
              hide: true, // 隐藏列
              showColumn: false // 是否加入动态现隐列
            },
            {
              label: '操作时间',
              prop: 'created_at',
              type: 'datetimerange',
              format: 'yyyy-MM-dd HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss',
              searchRange: true,
              search: true
            }
          ]
        }
      }
    }
  }
</script>
